import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { FooterText } from "../../../components/Common/FooterText";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const SectionTitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.text.primary,
  marginTop: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const FooterTypography = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(4),
  [theme.breakpoints.down("lg")]: {
    textAlign: "center",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const FooterTypographyTight = styled(FooterText)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("lg")]: {
    textAlign: "center",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
